// 客户端本地数据 AES-GCM 加密(WebCrypto)
// 说明:密钥存于本机,用于"静态加密"防止明文直接暴露;真正的端到端加密需服务端配合做密钥交换。

const KEY_STORAGE = 'cloakchat_enc_key';

function bytesToBase64(bytes: Uint8Array): string {
  let s = '';
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return btoa(s);
}

function base64ToBytes(b64: string): Uint8Array {
  const s = atob(b64);
  const out = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) out[i] = s.charCodeAt(i);
  return out;
}

async function getKey(): Promise<CryptoKey> {
  let raw = localStorage.getItem(KEY_STORAGE);
  if (!raw) {
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    raw = bytesToBase64(bytes);
    localStorage.setItem(KEY_STORAGE, raw);
  }
  return crypto.subtle.importKey('raw', base64ToBytes(raw), 'AES-GCM', false, ['encrypt', 'decrypt']);
}

export async function encryptText(plain: string): Promise<string> {
  const key = await getKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const data = new TextEncoder().encode(plain);
  const ct = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, data);
  const merged = new Uint8Array(iv.length + ct.byteLength);
  merged.set(iv, 0);
  merged.set(new Uint8Array(ct), iv.length);
  return bytesToBase64(merged);
}

export async function decryptText(cipher: string): Promise<string> {
  const key = await getKey();
  const merged = base64ToBytes(cipher);
  const iv = merged.slice(0, 12);
  const ct = merged.slice(12);
  const data = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ct);
  return new TextDecoder().decode(data);
}

export async function isEncryptionAvailable(): Promise<boolean> {
  try {
    if (!crypto?.subtle) return false;
    const t = await encryptText('probe');
    await decryptText(t);
    return true;
  } catch {
    return false;
  }
}
